module.exports = __webpack_public_path__ + "img/saishianpai-icon-1.9cde86ac.png";